module.exports = __webpack_public_path__ + "img/text_geju.be2eb248.png";